import './styles/nav.css'
import { Link } from 'react-router-dom'

export default function Nav({type = ''}) {
    if(type === 'faq'){
        return (
            <nav className='nav'>
                <ul className='nav__body faq-nav'>
                    <li className='nav__item dark'>
                        <Link to="/">Home</Link>
                    </li>
                    <li className='nav__item two dark'>
                        <a href="#features">Features</a>
                    </li>
                    <li className='nav__item three dark'>
                        <a href="#extension">Extension</a>
                    </li>
                    <li className='nav__item four dark'>
                        <a href="#pricing">Pricing</a>
                    </li>
                    <li className='nav__item dark'>
                        <a href="#blog">Blog</a>
                    </li>
                    <li className='nav__item dark'>
                        <a href="#contact-us">Contact us</a>
                    </li>
                </ul>
            </nav>
          )
    }

    return (
    <nav className='nav'>
        <ul className='nav__body'>
            <li className='nav__item'>
                <Link to="/">Home</Link>
            </li>
            <li className='nav__item two'>
                <a href="#features">Features</a>
            </li>
            <li className='nav__item three'>
                <a href="#extension">Extension</a>
            </li>
            <li className='nav__item four'>
                <a href="#pricing">Pricing</a>
            </li>
            <li className='nav__item'>
                <a href="#blog">Blog</a>
            </li>
            <li className='nav__item'>
                <a href="#contact-us">Contact us</a>
            </li>
        </ul>
    </nav>
  )
}
